export default __webpack_public_path__ + "static/media/screen-covid-dashboard-min.28619abe.png";